import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocationGeoResult } from "../../../model/country_state_city_area/GeoLocationModel";

interface CountryStateCityAreaInterface {
  timestamp: number;
  country: LocationGeoResult | null;
  state: LocationGeoResult | null;
  city: LocationGeoResult | null;
  area: LocationGeoResult | null;
  geo: CountryStateCityAreaGeoInterface | null;
}

interface CountryStateCityAreaGeoInterface {
  country: LocationGeoResult | null;
  state: LocationGeoResult | null;
  city: LocationGeoResult | null;
  area?: LocationGeoResult | null;
  nearBy?: boolean;
}

const initialState: CountryStateCityAreaInterface = {
  timestamp: Date.now(),
  country: null,
  state: null,
  city: null,
  area: null,
  geo: null,
};

const countrystatecityareaSlice = createSlice({
  name: "countrystatecityarea",
  initialState,
  reducers: {
    resfreshGeo: (state) => {
      state.timestamp = Date.now();
    },
    updateGeoCountry: (state, action: PayloadAction<LocationGeoResult>) => {
      state.country = action.payload;
      state.state = null;
      state.city = null;
      state.area = null;
      state.geo = null;
    },
    updateGeoState: (state, action: PayloadAction<LocationGeoResult>) => {
      state.state = action.payload;
      state.city = null;
      state.area = null;
      state.geo = null;
    },
    updateGeoCity: (state, action: PayloadAction<LocationGeoResult>) => {
      state.city = action.payload;
      state.area = null;
      state.geo = null;
    },
    updateGeoArea: (state, action: PayloadAction<LocationGeoResult>) => {
      state.area = action.payload;
      state.geo = null;
    },
    setupGeoDetail: (
      state,
      action: PayloadAction<CountryStateCityAreaGeoInterface>
    ) => {
      state.country = action.payload.country;
      state.state = action.payload.state;
      state.city = action.payload.city;
      state.area = action.payload.area!;
      state.geo = {
        country: action.payload.country,
        state: action.payload.state,
        city: action.payload.city,
        area: action.payload.area,
        nearBy: action.payload.nearBy ?? false,
      };
    },
    getSubmitGEO: (
      state,
      action: PayloadAction<CountryStateCityAreaGeoInterface>
    ) => {
      state.geo = {
        country: action.payload.country,
        state: action.payload.state,
        city: action.payload.city,
        area: action.payload.area,
        nearBy: action.payload.nearBy ?? false,
      };
    },
    getGEO: (state) => {
      state.geo = {
        country: state.country,
        state: state.state,
        city: state.city,
        area: state.area,
        nearBy: state.geo?.nearBy ?? false,
      };
    },
  },
});

export const {
  resfreshGeo,

  updateGeoCountry,
  updateGeoState,
  updateGeoCity,
  updateGeoArea,

  setupGeoDetail,

  getSubmitGEO,
  getGEO,
} = countrystatecityareaSlice.actions;

export default countrystatecityareaSlice.reducer;
